// 本来であればIDocumentFactryRequestやRequestedObject等の従来実装を踏まえて拡張すべきだが、既存のモデルがあまりよくない。
// ・中途半端にインターフェースとクラスが混在している。
// ・省略可能なメンバが分からない。
// 幸い注入時の実装は修正不要(拡張された情報は必要ない)なので、新たに最適なモデルを実装する。(従来Docu3設計に合わせてクラスで実装。)
// 将来的に注入時の実装にも拡張された情報が必要になる場合、本実装ベースのモデルへの置き換えを検討する事。

export class DocumentInjectedData {
  constructor(
    public objects: DocumentInjectedObject[],
    public evidences: DocumentInjectedEvidence[],
  ) {
  }
}

export class DocumentInjectedObject {
  constructor(
    public id: string | null,
    public key: string | null,
    public value: string,
    public label: string | null,
    public grounds: DocumentInjectedGround[],
  ) {
  }
}

export class DocumentInjectedGround {
  constructor(
    public reason: string | null,
    public evidenceKey: string | null,
    public isReliable: boolean,
  ) {
  }
}

export type DocumentInjectedContentType = "text" | "html" | "url";

export class DocumentInjectedEvidenceBase<T extends DocumentInjectedContentType> {
  constructor(
    public key: string,
    public type: T,
    public isReliable: boolean,
    public name: string | null,
    public description: string | null,
    public createdAt: Date | null,
    public department: string | null,
    public writtenBy: DocumentInjectedEvidenceAuthor | null,
  ) {
  }
}

export class DocumentInjectedEvidenceAuthor {
  constructor(
    public name: string,
    public role: string | null,
  ) {
  }
}

export class DocumentInjectedEvidenceText extends DocumentInjectedEvidenceBase<"text"> {
  constructor(
    key: string,
    public text: string,
    isReliable: boolean,
    name: string | null,
    description: string | null,
    createdAt: Date | null,
    department: string | null,
    writtenBy: DocumentInjectedEvidenceAuthor | null,
  ) {
    super(key, "text", isReliable, name, description, createdAt, department, writtenBy);
  }
}

export class DocumentInjectedEvidenceHtml extends DocumentInjectedEvidenceBase<"html"> {
  constructor(
    key: string,
    public html: string,
    isReliable: boolean,
    name: string | null,
    description: string | null,
    createdAt: Date | null,
    department: string | null,
    writtenBy: DocumentInjectedEvidenceAuthor | null,
  ) {
    super(key, "html", isReliable, name, description, createdAt, department, writtenBy);
  }
}

export class DocumentInjectedEvidenceUrl extends DocumentInjectedEvidenceBase<"url"> {
  constructor(
    key: string,
    public url: string,
    isReliable: boolean,
    name: string | null,
    description: string | null,
    createdAt: Date | null,
    department: string | null,
    writtenBy: DocumentInjectedEvidenceAuthor | null,
  ) {
    super(key, "url", isReliable, name, description, createdAt, department, writtenBy);
  }
}

export type DocumentInjectedEvidence = DocumentInjectedEvidenceText | DocumentInjectedEvidenceHtml | DocumentInjectedEvidenceUrl;
